import { focusAtom } from 'jotai-optics';
import { appAtom } from './appAtom';

export const surveyServiceAtom = focusAtom(appAtom, (optic) =>
  optic.prop('service')
);
